// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type MemoryQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type MemoryQuery = {
  __typename?: "GraphqlQuery";
  getSystemStats?: {
    __typename?: "SystemStatsSeries";
    id: string;
    memoryTotal?: Array<Array<number | null> | null> | null;
    memoryFree?: Array<Array<number | null> | null> | null;
    memoryPageCache?: Array<Array<number | null> | null> | null;
    memoryBuffers?: Array<Array<number | null> | null> | null;
    memoryProcess?: Array<Array<number | null> | null> | null;
    memorySwap?: Array<Array<number | null> | null> | null;
  } | null;
};

export const MemoryDocument = gql`
  query Memory($serverId: ID!, $startTs: Int!, $endTs: Int!) {
    getSystemStats(serverId: $serverId, startTs: $startTs, endTs: $endTs) {
      id
      memoryTotal
      memoryFree
      memoryPageCache
      memoryBuffers
      memoryProcess
      memorySwap
    }
  }
`;

/**
 * __useMemoryQuery__
 *
 * To run a query within a React component, call `useMemoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemoryQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useMemoryQuery(
  baseOptions: Apollo.QueryHookOptions<MemoryQuery, MemoryQueryVariables> &
    ({ variables: MemoryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemoryQuery, MemoryQueryVariables>(
    MemoryDocument,
    options,
  );
}
export function useMemoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MemoryQuery, MemoryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemoryQuery, MemoryQueryVariables>(
    MemoryDocument,
    options,
  );
}
// @ts-ignore
export function useMemorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MemoryQuery,
    MemoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MemoryQuery, MemoryQueryVariables>;
export function useMemorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemoryQuery, MemoryQueryVariables>,
): Apollo.UseSuspenseQueryResult<MemoryQuery | undefined, MemoryQueryVariables>;
export function useMemorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemoryQuery, MemoryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemoryQuery, MemoryQueryVariables>(
    MemoryDocument,
    options,
  );
}
export type MemoryQueryHookResult = ReturnType<typeof useMemoryQuery>;
export type MemoryLazyQueryHookResult = ReturnType<typeof useMemoryLazyQuery>;
export type MemorySuspenseQueryHookResult = ReturnType<
  typeof useMemorySuspenseQuery
>;
export type MemoryQueryResult = Apollo.QueryResult<
  MemoryQuery,
  MemoryQueryVariables
>;
